export const CREATE_PRODUCT_FOAM = 'CREATE_PRODUCT_FOAM'
export const GET_LIST_PRODUCT_FOAM = 'GET_LIST_PRODUCT_FOAM'
export const DETAIL_PRODUCT_FOAM = 'DETAIL_PRODUCT_FOAM'
export const PATCH_PRODUCT_FOAM = 'PATCH_PRODUCT_FOAM'
